import type { StandardSchemaV1Issue } from '@tanstack/react-form';
import { type PropsWithChildren } from 'react';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@virtual-care/shadcn';

export function CreateDialog({
  trigger,
  title,
  children,
  subtitle,
  form,
  ...props
}: PropsWithChildren<{
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  title: string;
  subtitle: string;
  trigger: React.ReactNode;
  /**
   * If false, the dialog cannot be closed by clicking outside or pressing Escape.
   * So dialig can only be closed programmatically and by doing so the form will be reset.
   */
  closable?: boolean;
  form: {
    handleSubmit: () => Promise<unknown>;
    reset: () => unknown;
    state: { errors: (Record<string, StandardSchemaV1Issue[]> | undefined)[] };
  };
  onSave?: () => void;
}>) {
  const handleOpenChange = (isOpen: boolean) => {
    props.onOpenChange?.(isOpen);
    if (props.closable === false) {
      // Reset form to original values when dialog closes
      form.reset();
    } else {
      if (!isOpen) {
        // Reset form to original values when dialog closes
        form.reset();
      }
    }
  };
  return (
    <Dialog open={props.open} onOpenChange={handleOpenChange} modal={true}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent
        className="sm:max-w-2xl"
        onInteractOutside={(e) => {
          if (props.closable === false) {
            e.preventDefault();
          }
        }}
        onEscapeKeyDown={(e) => {
          if (props.closable === false) {
            e.preventDefault();
          }
        }}
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{subtitle}</DialogDescription>
        </DialogHeader>
        <form
          className="space-y-4"
          onSubmit={async (e) => {
            e.preventDefault();
            e.stopPropagation();
            await form.handleSubmit();
            await props.onSave?.();
          }}
        >
          {children}
        </form>
      </DialogContent>
    </Dialog>
  );
}
